import { Component, Input } from "@angular/core";
import { SectionHeaderComponent } from "../../../../../shared/section-header/section-header.component";
import { TableModule } from "primeng/table";

import { ValidatedTickets } from "@models/validated-tickets";

@Component({
    selector: "app-validated-tickets-table",
    imports: [SectionHeaderComponent, TableModule],
    templateUrl: "./validated-tickets-table.component.html",
    styleUrl: "./validated-tickets-table.component.scss"
})
export class ValidatedTicketsTableComponent {
  totalIssued = 0;
  totalValidated = 0;
  private _data: ValidatedTickets[] = [];
  @Input({ required: true }) set data(data: ValidatedTickets[]) {
    this._data = data;
    this.updateTotals();
  }

  get data() {
    return this._data;
  }

  updateTotals() {
    this.data.forEach((dataEntry) => {
      this.totalIssued += dataEntry.total_emitted;
      this.totalValidated += dataEntry.total_validated;
    });
  }
}
